import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

export const ScoringGridSummary = ({ scoringGrid }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} direction="row" sx={{ fontSize: "14px" }}>
      <Grid item xs={12} sm={4}>
        <strong>{t("Scoring.Result")}</strong> : <span>{scoringGrid ? scoringGrid.result : ""}</span>
      </Grid>
      <Grid item xs={12} sm={4} md={4}>
        <strong>{t("Scoring.FinalScore")}</strong> : <span>{scoringGrid ? scoringGrid.finalScore : ""}</span>
      </Grid>
    </Grid>
  );
};

ScoringGridSummary.propTypes = {
  scoringGrid: PropTypes.object
};

export default ScoringGridSummary;
